import React from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import './App.css'
import 'antd/dist/reset.css'

import { AuthorInfoPage } from './pages/AuthorInfoPage'
import { DetailsPage } from './pages/DetailsPage'
import { IndexPage } from './pages/IndexPage'
import { ProfessionPage } from './pages/ProfessionPage'
import { LoginPage } from './pages/LoginPage'
import { AuthRouter } from './components/AuthRouter'
import { AdminPage } from './pages/AdminPage'
import { IndexSecondPage } from './pages/IndexSecondPage'
import { SearchResultPage } from './pages/SearchResultPage'

function App() {
  return (
    <div className='App'>
      <Router>
        <Routes>
          <Route path='/' element={<LoginPage />} />
          <Route
            path='/author'
            element={
              <AuthRouter path='/author'>
                <AuthorInfoPage />
              </AuthRouter>
            }
          />
          <Route
            path='/details/:workId/:imageId'
            element={
              <AuthRouter path='/details'>
                <DetailsPage />
              </AuthRouter>
            }
          />
          <Route
            path='/index'
            element={
              <AuthRouter path='/index'>
                <IndexPage />
              </AuthRouter>
            }
          />
          <Route
            path='/indexSecond'
            element={
              <AuthRouter path='/indexSecond'>
                <IndexSecondPage />
              </AuthRouter>
            }
          />
          <Route
            path='/searchResult'
            element={
              <AuthRouter path='/searchResult'>
                <SearchResultPage />
              </AuthRouter>
            }
          />
          {/* <Route path="/faction" element={<Faction />} /> */}
          <Route
            path='/analysis'
            element={
              <AuthRouter path='/analysis'>
                <ProfessionPage />
              </AuthRouter>
            }
          />
          <Route
            path='/admin'
            element={
              <AuthRouter path='/admin'>
                <AdminPage />
              </AuthRouter>
            }
          />
        </Routes>
      </Router>
    </div>
  )
}

export default App
